import { SideMenuIcons } from "../enums";
import { env } from "../environment";

export const generateSidebarIconUrl = (icon: SideMenuIcons): string => {
  return `${env.filesUrl}/Icons/side-menu-${icon}.png`;
};
